// Which status a timeline card should show for a trip component.
//
// Components are created with status "pending" by default and nothing updates
// it for booked travel, so for flights, hotels and rental cars that value
// carries no information: they are booked reservations (we hold the PNR or
// confirmation number). Only a cancellation is worth showing for them. Other
// components (meetings, restaurants, events, chauffeur requests...) have a
// status people actually set, and it is shown as is.
export const BOOKED_RESERVATION_TYPES = ['commercial_flight', 'private_flight', 'hotel', 'rental_car'];

export function displayStatus(component = {}) {
  const status = String(component.status || '').toLowerCase();
  if (BOOKED_RESERVATION_TYPES.includes(component.component_type)) {
    return status.includes('cancel') ? 'cancelled' : null;
  }
  return status || 'pending';
}
